module.exports = __webpack_public_path__ + "static/img/about_msg_02_zh.248daea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_msg_02_zh.png
// module id = 2H2u
// module chunks = 34